// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k2Mx","icon":"styles_icon__1nxab"};